import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerComponent } from './spinner/spinner.component';
import { MenuItems } from './components/menu-items/menu-items';
import { ClickOutsideModule } from 'ng-click-outside';
import { AccordionAnchorDirective } from './components/accordion/accordionanchor.directive';
import { AccordionLinkDirective } from './components/accordion/accordionlink.directive';
import { AccordionDirective } from './components/accordion/accordion.directive';
import { ScrollModule } from './components/scroll/scroll.module';
import { CalendarModule } from 'angular-calendar';
import { AgmCoreModule } from '@agm/core';
import { TagInputModule } from 'ngx-chips';
import { AnimatorModule } from 'css-animator';
import { TitleComponent } from '../layout/admin/title/title.component';
import { DataTableModule } from 'angular2-datatable';
import { DataFilterPipe } from './components/data-table/data-filter.pipe';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SelectModule } from 'ng-select';
import { SelectOptionService } from './components/select-2/select-option.service';
import { FileUploadModule } from 'ng2-file-upload';
import { ColorPickerModule } from 'ngx-color-picker';
import { DatepickerModule } from 'angular2-material-datepicker';
import { ChartistModule } from 'ng-chartist';
import { QuillEditorModule } from 'ngx-quill-editor';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    ClickOutsideModule,
    ScrollModule,
    CalendarModule.forRoot(),
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyCE0nvTeHBsiQIrbpMVTe489_O5mwyqofk' }),
    TagInputModule,
    AnimatorModule,
    DataTableModule,
    NgxDatatableModule,
    SelectModule,
    FileUploadModule,
    ColorPickerModule,
    DatepickerModule,
    ChartistModule,
    QuillEditorModule
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    SpinnerComponent,
    TitleComponent,
    DataFilterPipe
  ],
  exports: [
    HttpModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    SpinnerComponent,
    TitleComponent,
    ClickOutsideModule,
    ScrollModule,
    CalendarModule,
    AgmCoreModule,
    TagInputModule,
    AnimatorModule,
    DataTableModule,
    DataFilterPipe,
    NgxDatatableModule,
    SelectModule,
    FileUploadModule,
    ColorPickerModule,
    DatepickerModule,
    ChartistModule,
    QuillEditorModule
  ],
  providers: [
    MenuItems,
    SelectOptionService
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts